function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "72",
  height: "51",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("rect", {
  x: "1",
  y: ".5",
  width: "70",
  height: "50",
  rx: "1.5",
  fill: "#FAFAFA"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M38.289 21.584h-1.47v1.157h-2.297v-1.157h-1.45l.535-.197-.433-6.576c.01-1.968.844-3.96 2.412-5.587l.006-.006a.05.05 0 01.011-.006.21.21 0 01.077-.012.233.233 0 01.089.016c1.581 1.64 2.408 3.628 2.418 5.61l-.433 6.56.535.198zm1.098-6.72l-.377 5.706.626.23a.8.8 0 01.524.751v1.768a.68.68 0 01-1.275.331l-.483-.866h-.383v.357a.8.8 0 01-.8.8h-3.097a.8.8 0 01-.8-.8v-.357h-.382l-.486.873a.67.67 0 01-1.254-.326v-1.78a.8.8 0 01.524-.75l.627-.23-.377-5.722c0-2.323.978-4.62 2.748-6.457.243-.256.588-.392.958-.392.371 0 .716.136.946.376 1.79 1.853 2.761 4.15 2.761 6.489z",
  fill: "#59C3C3"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M32.94 12.105c.644.24 1.7.41 2.92.41 1.227 0 2.281-.17 2.918-.41l.282.75c-.76.285-1.919.46-3.2.46-1.276 0-2.435-.175-3.2-.46l.28-.75zM35.2 16.32c0 .263.217.48.48.48.264 0 .48-.217.48-.48a.482.482 0 00-.48-.48.482.482 0 00-.48.48zm-.8 0c0 .704.575 1.28 1.28 1.28.706 0 1.28-.576 1.28-1.28 0-.706-.574-1.28-1.28-1.28-.705 0-1.28.574-1.28 1.28z",
  fill: "#59C3C3"
}), /*#__PURE__*/React.createElement("rect", {
  x: "25.5",
  y: "28",
  width: "21",
  height: "2",
  rx: "1",
  fill: "#DDE0E4"
}), /*#__PURE__*/React.createElement("rect", {
  x: "16.5",
  y: "34",
  width: "39",
  height: "2",
  rx: "1",
  fill: "#DDE0E4"
}), /*#__PURE__*/React.createElement("rect", {
  x: "26.5",
  y: "40",
  width: "19",
  height: "4",
  rx: "2",
  fill: "#59C3C3"
}), /*#__PURE__*/React.createElement("rect", {
  x: "1",
  y: ".5",
  width: "70",
  height: "50",
  rx: "1.5",
  stroke: "#DDE0E4"
})));